import { render, staticRenderFns } from "./CmgLeaderboardStats.vue?vue&type=template&id=09ef952e&scoped=true&lang=pug"
import script from "./cmg-leaderboard-stats.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-stats.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardStats.vue?vue&type=style&index=0&id=09ef952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef952e",
  null
  
)

export default component.exports